import { type Maybe, type Video, type VideoType } from '@tmdb-graphql-api/schema/types';
import { baseUrls } from '../enums/videos.ts';

export const buildVideoPaths = (
  videos: Maybe<Maybe<Video>[]> | undefined,
  options: { count?: number; types?: VideoType[] } = {},
) =>
  (videos ?? []).reduce((acc: string[], video) => {
    if (!video || (options.count && acc.length >= options.count)) {
      return acc;
    }

    const { key, site, type } = video;

    if (!options.types) {
      acc.push(`${baseUrls[site]}${key}`);
    } else if (options.types.includes(type)) {
      acc.push(`${baseUrls[site]}${key}`);
    }

    return acc;
  }, []);
